import React from 'react';

import {
  PhoneConfirmationFormValues,
  PhoneConfirmationFormViolation,
} from 'types/phoneConfirmationFormTypes';
import { createPhoneConfirmationFormValues } from 'utils/validatePhoneConfirmationFormValues';

export const usePhoneConfirmationForm = () => {
  const [values, setValues] = React.useState<PhoneConfirmationFormValues>(
    createPhoneConfirmationFormValues
  );

  const [violations, setViolations] = React.useState<
    PhoneConfirmationFormViolation[]
  >([]);

  const setPhoneValue = React.useCallback((nextValue?: string) => {
    setValues((prev) => ({
      ...prev,
      phone: nextValue ?? '',
    }));

    setViolations((prev) =>
      prev.filter((violation) => violation.name !== 'PhoneInvalid')
    );
  }, []);

  const setCodeValue = React.useCallback((nextValue: string[]) => {
    setValues((prev) => ({
      ...prev,
      code: nextValue,
    }));

    setViolations((prev) =>
      prev.filter(
        (violation) =>
          violation.name !== 'DigitMissed' && violation.name !== 'InvalidCode'
      )
    );
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setPhoneValue,
    setCodeValue,
  };
};
